import React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import "./style.scss";

import UploadStatusTable from "./components/UploadStatusTable";

import UploadFile from "./components/UploadFile";

const AdminUpload = ({ expiration, user_type }) => {
  const uploadModules = [
    {
      id: 1,
      title: "Upload Outlet Status",
      api: "/upload-outlet-status",
      userTypes: ["bkash-super-user", "area_manager"],
      // helpText: "Select from computer",
    },
    {
      id: 20,
      title: "Reset Route Outlet Mapping",
      api: "/upload-reset-route-outlet-mapping",
      userTypes: ["bkash-super-user"],
    },
    {
      id: 2,
      title: "Upload Outlet Campaign",
      api: "/upload-outlet-campaign",
      userTypes: ["bkash-super-user", "area_manager"],
    },
    {
      id: 3,
      title: "Upload Spots",
      api: "/upload-spots",

      userTypes: ["bkash-super-user", "territory_manager", "area_manager"],
    },
    {
      id: 4,
      title: "Upload Outlet Tagging",
      api: "/upload-outlet-tagging",

      userTypes: ["bkash-super-user", "territory_manager", "area_manager"],
    },

    {
      id: 5,
      title: "Upload MDO Spots Mapping",
      api: "/spot-mapping-update",
      userTypes: ["bkash-super-user", "territory_manager", "area_manager"],
    },
    {
      id: 6,
      title: "Upload Distributor",
      api: "/upload-agencies",
      userTypes: ["bkash-super-user", "area_manager"],
    },
    {
      id: 12,
      title: "Upload Distributor Target",
      api: "/upload-agency-target",
      userTypes: ["bkash-super-user", "area_manager"],
    },
    {
      id: 7,
      title: "Upload Merchant Bill Info",
      api: "/upload-bill-info",
      userTypes: ["bkash-super-user", "area_manager"],
    },
    {
      id: 8,
      title: "Upload route info",
      api: "/upload-route-info",
      userTypes: ["bkash-super-user", "territory_manager", "area_manager"],
    },
    {
      id: 9,
      title: "Outlet route mapping",
      api: "/upload-route-outlet-mapping",
      userTypes: ["bkash-super-user", "territory_manager", "area_manager"],
    },
    {
      id: 10,
      title: "Field force route mapping",
      api: "/upload-route-mmo-mapping",
      userTypes: ["bkash-super-user", "territory_manager", "area_manager"],
    },
    {
      id: 11,
      title: "Merchant KYC upload",
      api: "/upload-merchant-kyc-data",
      userTypes: ["bkash-super-user"],
    },
    {
      id: 12,
      title: "Agency Thana-District Mapping",
      api: "/upload-agencies-geography",
      userTypes: ["bkash-super-user"],
    },
    {
      id: 13,
      title: "Outlet Lat Lng Mapping",
      api: "/upload-outlet-lat-lng",
      userTypes: ["bkash-super-user"],
    },
    {
      id: 14,
      title: "Agency Lat Long Mapping",
      api: "/upload-agency-lat-lng",
      userTypes: ["bkash-super-user"],
    },
    {
      id: 15,
      title: "Categorization Validation Uploader",
      api: "/upload-merchant-categorization-validator",
      varients: [
        {
          id: "BUSINESS_PILLAR_SUB_PILLAR",
          name: "BUSINESS PILLAR SUB PILLAR",
        },
        {
          id: "SUB_PILLAR_CATEGORY",
          name: "SUB PILLAR MERCHANT CATEGORY",
        },
        {
          id: "MERCHANT_CATEGORY_SUB_CATEGORY",
          name: "MERCHANT CATEGORY MERCHANT SUB CATEGORY",
        },
        {
          id: "MERCHANT_IRRELATIONSHIP_FIELDS",
          name: "MERCHANT CATEGORIZATION FIELDS",
        },
        { id: "BMCC_CODE_NAME", name: "BMCC CODE NAME" },
        { id: "MCC_CODE_NAME", name: "MCC CODE NAME" },
      ],
      userTypes: ["bkash-super-user"],
    },
    {
      id: 16,
      title: "Upload Distributor Target",
      api: "/upload-agency-target",
      userTypes: ["bkash-super-user"],
    },
    {
      id: 17,
      title: "Upload Route Target",
      api: "/upload-route-target",
      userTypes: ["bkash-super-user"],
    },
    {
      id: 18,
      title: "Upload Employee target",
      api: "/upload-field-force-target",
      userTypes: ["bkash-super-user"],
    },
    {
      id: 19,
      title: "Upload Acquisition Target Configuration",
      api: "/upload-acquisition-target-configuration",
      userTypes: ["bkash-super-user"],
    },
  ];

  const onlineUploadModules = [
    {
      id: 8,
      title: "Upload Lead Tagging",
      api: "/upload-online-lead-tagging",
      scope: "online",
    },
    {
      id: 9,
      title: "Upload Lead Registration",
      api: "/upload-online-registration-status",
      scope: "online",
    },
    {
      id: 10,
      title: "Upload Online MAO Target",
      api: "/upload-online-mao-target",
      scope: "online",
    },
  ];

  const localUserToken = JSON.parse(localStorage.getItem("currUserToken"));
  const scope = localStorage.getItem("scope");
  const modules =
    scope && scope === "online" ? [...onlineUploadModules] : [...uploadModules];
  if (!localUserToken) return <Redirect to="/signin" />;

  if (
    user_type !== "bkash-super-user" &&
    user_type !== "territory_manager" &&
    user_type !== "area_manager" &&
    user_type !== "cluster_head"
  )
    return <Redirect to="/" />;

  let current_time = Date.now().valueOf() / 1000;
  if (expiration < current_time) this.props.signOut();

  const filteUserTypePermission = (i) => {
    var filterPass = false;
    if (!i.userTypes) return true;
    if (i.userTypes)
      i.userTypes.map((userType) => {
        if (userType === user_type) filterPass = true;
      });
    return filterPass;
  };

  return (
    <div className="main-container">
      <div className="AdminUpload-container">
        <div className="page-header">
          <div className="page-heading">
            Admin Upload
            <div className="page-sub-heading">
              Upload necessary files using this portal
            </div>
          </div>
        </div>

        <div className="card-row row">
          {modules.filter(filteUserTypePermission).map((module) => (
            <div key={module.id} className="card-col col s12 m6 l6 ">
              <UploadFile
                heading={module.title}
                api={module.api}
                help={module.helpText ? module.helpText : null}
                varients={module.varients || []}
              />
            </div>
          ))}
        </div>

        <div className="card-row row">
          <UploadStatusTable />
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  let expiration = state.auth.authToken
    ? state.auth.authToken.expiration
    : 20000;

  let user_type = state.auth.authToken ? state.auth.authToken.type : null;

  return { expiration, user_type };
};
export default connect(mapStateToProps)(AdminUpload);
